/**
 * One rolling-session policy for every long-lived credential the client
 * holds: the Morfi backend session (web cookie / RN bearer) and the Turnkey
 * signing session. Both live seven days and both are extended on any visit
 * once they are a day old, so the guarantee is the same everywhere: a user
 * loses a session only by staying away for a full week since their last
 * visit.
 *
 * The backend's `SESSION_EXPIRY_SECONDS` / `SESSION_REFRESH_LEAD_SECONDS` and
 * the Turnkey auth-proxy `sessionExpirationSeconds` hold the same numbers and
 * are kept in sync by hand.
 */

const DAY_MS = 24 * 60 * 60 * 1000;

/** Lifetime of a freshly minted or freshly extended session. */
export const SESSION_TTL_MS = 7 * DAY_MS;

/** Extend on any visit once the session has aged this much. */
export const SESSION_REFRESH_MIN_AGE_MS = DAY_MS;

/**
 * The same rule expressed as "remaining life", for clients that only learn
 * the expiry and not the issue time (the web cookie).
 */
export const SESSION_REFRESH_REMAINING_MS = SESSION_TTL_MS - SESSION_REFRESH_MIN_AGE_MS;

/**
 * Minimum interval between proactive refreshes. Guards multi-tab stampedes
 * where each refresh replaces the stored credential.
 */
export const SESSION_REFRESH_THROTTLE_MS = 60 * 60 * 1000;
